/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import CommentVotes from './CommentVotes';
import UserInfo from './UserInfo';

function CommentItem({
  id, content, createdAt, owner, upVotesBy, downVotesBy, authUser,
}) {
  return (
    <div className="comment-item">
      <UserInfo avatar={owner.avatar} name={owner.name} createdAt={createdAt} />
      <article className="thread-item__article">
        <p className="thread-item__text" dangerouslySetInnerHTML={{ __html: content }} />
      </article>
      <CommentVotes
        id={id}
        upVotesBy={upVotesBy}
        downVotesBy={downVotesBy}
        authUser={authUser}
      />
    </div>
  );
}

const userShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

const ownerShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  avatar: PropTypes.string,
};

const commentItemShape = {
  id: PropTypes.string,
  content: PropTypes.string,
  createdAt: PropTypes.string,
  owner: PropTypes.shape(ownerShape).isRequired,
  upVotesBy: PropTypes.arrayOf(PropTypes.string).isRequired,
  downVotesBy: PropTypes.arrayOf(PropTypes.string).isRequired,
  authUser: PropTypes.shape(userShape).isRequired,
};

CommentItem.propTypes = {
  ...commentItemShape,
};

export default CommentItem;
